import Swal from "sweetalert2";
import AXIOS from "../../config/axios";

export const fetchAllSiteList = async () => {
  try {
    const res = await AXIOS.get("/sites/lists");
    return res.data;
  } catch (error) {
    console.log(error);
    Swal.fire(error.message);
  }
};



const fetchSiteList = async () => {
  try {
    const res = await AXIOS.get("/sites/list");
    return res.data;
  } catch (error) {
    console.log(error);
    Swal.fire(error.message);
  }
};
export default fetchSiteList;
